module.exports = __webpack_public_path__ + "static/media/Oakbrook-Pointe-By-Laws.8b9f3c96.pdf";